import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { FeatureToggle } from './toggles.types';
import { AllMe } from '../enode/enode.types';

@Injectable({
  providedIn: 'root'
})
export class FeatureTogglesService {
  togglesUrl = 'https://apiprivat.ishavskraft.no/v2/admin/toggles';
  hostUrl = 'https://appgw.prod.iktest.co';
  appApiUrl = `${this.hostUrl}/api-app`;

  constructor(private _httpClient: HttpClient) {}

  getAllFeatureToggles(): Observable<FeatureToggle[]> {
    return this._httpClient.get<FeatureToggle[]>(`${this.togglesUrl}/all`);
  }

  getActiveFeatureToggles(): Observable<FeatureToggle[]> {
    return this._httpClient.get<FeatureToggle[]>(`${this.togglesUrl}/active`);
  }

  private getAllMe(): Observable<AllMe> {
    return this._httpClient.get<AllMe>(`${this.appApiUrl}/me/all`);
  }

  getHasEnodeFeature() {
    return this.getAllMe().pipe(map((res) => res.features.includes('enode')));
  }
}
